import * as React from 'react'
import createSvgIcon from './createSvgIcon'
import { BrandColors } from 'style/BrandColors'

export default createSvgIcon(
  <React.Fragment>
    <path
      d="M11.9933 1.00195C12.3738 1.00208 12.7213 1.21833 12.8898 1.55957L15.7423 7.34082L22.1222 8.26562C22.4991 8.32025 22.8122 8.58407 22.9298 8.94629C23.0473 9.30842 22.9496 9.70607 22.6769 9.97168L18.0538 14.4717L19.1437 20.8262C19.2079 21.2014 19.0533 21.5811 18.7452 21.8047C18.4371 22.0282 18.0283 22.0574 17.6915 21.8799L11.9982 18.8799L6.29307 21.8799C5.95617 22.057 5.54826 22.0274 5.24034 21.8037C4.93248 21.58 4.7777 21.2012 4.8419 20.8262L5.93175 14.4717L1.30968 9.97168C1.03683 9.70609 0.938244 9.30845 1.05577 8.94629C1.17338 8.58413 1.48656 8.3203 1.86339 8.26562L8.24229 7.34082L11.0958 1.55957C11.2643 1.21823 11.6126 1.00195 11.9933 1.00195Z"
      fill={BrandColors.mangoYellow}
    />
  </React.Fragment>,
  'Star-empty'
)
